import React from "react";
import "./preloader/preloader.css";
import preloaderImg from "../../assets/Images/home/pre_loader.png";

export default function Preloader() {
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-white z-50">
      
      <div className="loader">
        <img
          src={preloaderImg}
          alt="Loading"
          className="w-16 h-16"
        />
      </div>

    </div>
  );
}